import { Box } from '@theme-ui/components';
import styled from '@emotion/styled';

import { H3 } from '@app/components/typography';
import theme from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';

export const ContentWrapper = styled(Box)`
  max-width: ${theme.layout.containerMaxWidth};
  margin: 0 auto;
`;

export const LayoutSubtitle = styled(H3)`
  color: ${theme.colors.gray};
  margin: ${rem(10)} 0;
  font-weight: 500;
`;
